import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * INFO: add comment
 */
@Component({
    selector: 'ui-user-menu-avatar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="ui-user-menu-avatar-content">
            <div *ngIf="avatarValue" class="mat-h2 ui-user-menu-text-avatar">{{ avatarValue }}</div>
            <img *ngIf="avatarImage" [src]="'data:image/png;base64,' + avatarImage" alt="User Menu Avatar" />
            <ng-content></ng-content>
        </div>
    `,
    host: {
        class: 'ui-user-menu-avatar',
    },
    standalone: false,
})
export class UserMenuAvatarComponent {
    @Input() avatarValue: string;
    @Input() avatarImage: string;
}
